import React from "react";
import ReactDOM from "react-dom";
import BaseComponent from "../../../baseComponent.js";
import InternalEvent from "../../../../core/constants/internalEvent.js";
import styles from "./legends.scss";
import DatasetDetail from "./../../../data-bank/dataset-detail/datasetDetail.jsx";
import DatasetService from "../../../../core/services/datasetService.js";

export default class TableLegend extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.subscribe(InternalEvent.Dashboard.AddWidget.FIELD_DRAG_START, this.showDropIndicator);
    this.subscribe(InternalEvent.Dashboard.AddWidget.FIELD_DRAG_END, this.hideDropIndicator);
  }

  componentWillUnmount() {
    this.unsubscribeAll()
  }

  showDropIndicator() {
    $(this.refs.container)
      .css("min-height", "60px")
      .addClass(styles.dropActivated);
  }

  hideDropIndicator() {
    $(this.refs.container)
      .css("min-height", "20px")
      .removeClass(styles.dropActivated);
  }

  handleDrop(e) {

    e.preventDefault();
    let key = $(e.target).attr("data-key");
    let data = JSON.parse(e.dataTransfer.getData('data'));
    e.persist();

    DatasetService.checkUserDatasetSubscription(data.dataset.persistenceId).then(subscriptions => {
      if(subscriptions.length > 0){
        this.props.handleDrop(data);
      }
      else{
        this.props.callback(data);
      }
    });
  }

  dataStorage(data){
    this.setState(
      {
        data: data
      }
    );
  }


  preventDefault(e) {
    e.preventDefault();
  }

  render() {
    return (
      <div className={styles.tableLegend} ref="container"
           onDragOver={this.preventDefault} onDrop={this.handleDrop}>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/dashboard/add-widget/legends/tableLegend.jsx